<div class="component-container">
  <div class="top-bar">
    @for (logo of config().header.logos[device()]; track logo.imageUrl) {
      <img
        class="top-bar-logo"
        [src]="logo.imageUrl"
        [alt]="logo.alternativeText"
      />
    }
  </div>

  <div class="auth-content" role="main">
    <div class="hero">
      <div class="programmes">
        @for (programme of config().programmes; track programme.logo.imageUrl) {
          @if (isProgrammeShown(programme)) {
            <div
              class="programme {{ programme.theme }}"
              [attr.data-cy]="programme.requiresBisCampaign ? 'banner' : null"
            >
              <div class="programme-visuals">
                <img
                  class="programme-logo"
                  [src]="programme.logo.imageUrl"
                  [alt]="programme.logo.alternativeText"
                />
                <img
                  class="programme-sticker"
                  [src]="programme.sticker.imageUrl"
                  [alt]="programme.sticker.alternativeText"
                />
              </div>
              <p class="programme-text" [innerHTML]="programme.text"></p>
              @if (programme.footnote) {
                <p class="programme-footnote">{{ programme.footnote }}</p>
              }
            </div>
          }
        }
      </div>

      <div class="login-block" role="form">
        @let loginBlock = config().loginBlock;
        <h1 class="login-title" [innerHTML]="loginBlock.title"></h1>
        <div class="intro">
          <img
            class="intro-picture"
            [src]="loginBlock.intro.picture.imageUrl"
            [alt]="loginBlock.intro.picture.alternativeText"
          />
          <p class="intro-text">{{ loginBlock.intro.text }}</p>
        </div>

        <div class="form" data-cy="form" data-variant="variant2">
          <form [formGroup]="form">
            @for (item of loginBlock.fields; track item.formControlName) {
              @let secretToggle = loginBlock.secretToggle;
              @if (item.formControlName === secretToggle.formControlName) {
                <div class="secret-field">
                  <b2c-input
                    [type]="isSecretVisible() ? item.type : 'password'"
                    inputMode="numeric"
                    [numericOnly]="true"
                    [label]="item.label ?? ''"
                    [placeholder]="item.placeholder"
                    [attr.data-cy]="item.formControlName"
                    [formControlName]="item.formControlName"
                    [required]="item.required || false"
                    [errorMessages]="controlErrorMessages[item.formControlName]"
                    [autoComplete]="item.autoComplete || ''"
                  />
                  <button
                    type="button"
                    class="secret-toggle"
                    data-cy="secret_toggle"
                    [attr.aria-pressed]="isSecretVisible()"
                    [attr.aria-label]="
                      isSecretVisible()
                        ? secretToggle.hideLabel
                        : secretToggle.showLabel
                    "
                    (click)="toggleSecretVisibility()"
                  >
                    <img alt="" [src]="secretToggle.iconUrl" />
                  </button>
                </div>
              } @else {
                <b2c-input
                  [type]="item.type"
                  [label]="item.label ?? ''"
                  [placeholder]="item.placeholder"
                  [attr.data-cy]="item.formControlName"
                  [formControlName]="item.formControlName"
                  [required]="item.required || false"
                  [autoFocus]="item.formControlName === 'card'"
                  [errorMessages]="controlErrorMessages[item.formControlName]"
                  [autoComplete]="item.autoComplete || ''"
                />
              }
            }
          </form>

          <div class="links">
            <a
              class="link"
              target="_blank"
              [href]="loginBlock.linkToCard.url"
              [attr.aria-label]="loginBlock.linkToCard.ariaLabel"
              [title]="loginBlock.linkToCard.ariaLabel"
              >{{ loginBlock.linkToCard.label }}</a
            >
            <a
              class="link"
              [routerLink]="loginBlock.acceptModality.url"
              [attr.aria-label]="loginBlock.acceptModality.ariaLabel"
              [title]="loginBlock.acceptModality.ariaLabel"
              >{{ loginBlock.acceptModality.label }}</a
            >
          </div>

          @if (showErrorMessage()) {
            <div class="error" data-cy="login_error">
              {{ loginBlock.errorMessage }}
            </div>
          }

          <b2c-button
            class="submit-button"
            (click)="submit()"
            buttonType="submit"
            cssClass="login-cta"
            data-cy="login_button"
            [class.disabled]="form.invalid || formSubmitted()"
          >
            {{ loginBlock.submitButton.label }}
            <img alt="" [src]="loginBlock.submitButton.iconUrl" />
          </b2c-button>

          @let additionalInfoTemplate = loginBlock.additionalInfoTemplate;
          @if (additionalInfoTemplate) {
            <b2c-template [template]="additionalInfoTemplate" />
          }
        </div>
      </div>
    </div>
  </div>

  @if (
    config().howToPlay.specificDisplayCondition === DISPLAY_CONDITION.ALWAYS
  ) {
    <div class="how-to-play">
      <b2c-how-to-play [enableSwipe]="true" [config]="config().howToPlay" />
    </div>
  }

  @let templateBeforeChanges = config().templateBeforeChanges;
  @if (templateBeforeChanges) {
    <b2c-template class="astrics" [template]="templateBeforeChanges" />
  }

  <b2c-footer />
</div>
